import { useState } from "react";
import { gerarLinkWhatsApp } from "../../../utils/WhatsappLink";

export default function Footer() {
    const [isHover, setIsHover] = useState(false);

    return (
        <>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", padding: "40px 20px", backgroundColor: "#f5f5f5", }} >
                <div style={{ width: "700px", backgroundColor: "#050505", borderRadius: "18px", padding: "70px 60px", textAlign: "center", position: "relative", overflow: "hidden", }} >
                    <div style={{ position: "absolute", inset: 0, backgroundImage: "repeating-linear-gradient(135deg, rgba(255,255,255,0.03) 0px, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 40px)", pointerEvents: "none", }} />
                    <div style={{ position: "relative", zIndex: 1 }}>
                        <h2 style={{ color: "#fff", fontSize: "30px", fontWeight: 700, lineHeight: 1.2, margin: 0, fontFamily: "serif", }} >
                            Regularize sua situação antes que o Leão chegue primeiro.
                        </h2>
                        <p style={{ color: "#d1d5db", fontSize: "15px", lineHeight: 1.7, marginTop: "28px", marginBottom: "40px", maxWidth: "560px", marginInline: "auto", }} >
                            A ContBlack cuida de declarações em atraso, regularização de CPF e
                            CNPJ, e de toda a sua vida fiscal — de forma simples, digital e sem
                            enrolação.
                        </p>
                        <a
                            href={gerarLinkWhatsApp("Olá, vim pelo blog e gostaria de atendimento.")}
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "18px 36px", backgroundColor: isHover ? "#17e678" : "#1EFF86", color: "#000", borderRadius: "10px", textDecoration: "none", fontSize: "18px", fontWeight: 700, transition: "all 0.25s ease", transform: isHover ? "translateY(-2px)" : "translateY(0)", boxShadow: isHover ? "0 10px 24px rgba(30,255,134,0.35)" : "0 4px 12px rgba(30,255,134,0.18)", }} >
                            Falar com um especialista agora →
                        </a>
                    </div>
                </div>
            </div>
            <footer style={{ width: "100%", borderTop: "1px solid #e5e5e5", backgroundColor: "#f5f5f5", padding: "36px 20px", textAlign: "center", }} >
                <p style={{ margin: 0, fontSize: "13px", color: "#6b7280", lineHeight: 1.7, }} >
                    Artigo produzido pela equipe{" "}
                    <span style={{ color: "#000", fontWeight: 500, }} >
                        ContBlack
                    </span>{" "}
                    — Contabilidade digital para quem trabalha por conta própria e quer
                    crescer com segurança.
                </p>
                <p style={{ marginTop: "14px", marginBottom: 0, fontSize: "13px", color: "#6b7280", }} >
                    © {new Date().getFullYear()} ContBlack. Todos os direitos reservados.
                </p>
            </footer>
        </>
    );
}